<script setup lang="ts">
import { computed, inject, PropType } from "vue";
import { useCategoryFilter } from "@/composables/filters/category-filter";
import { Category } from "@/types/entities";
import type { PagingFilter } from "@/composables/filters/paging-filter";
import { pagingFilterSymbol } from "@/plugins/ContentFiltersPlugin";

const { includeCategoryFilter, resetSelectedCategories, toggleSelectedCategory } = useCategoryFilter();

const props = defineProps( {
  contentCategories: {
    type: Array as PropType< Category[] | undefined >,
    required: false
  } } );
const categories = computed< Category[] >( () => props.contentCategories ?? [] );

const pagingFilter = inject< PagingFilter >( pagingFilterSymbol ) as PagingFilter;
function resetPageNumber() {
  pagingFilter?.resetPageNumber();
}
</script>

<template>
  <div class="border dark:border-surface-600 rounded p-3">
    <div class="flex justify-between">
      <div class="text-sm text-gray-400">Filter by Category</div>
      <button :class="{ disabled: !includeCategoryFilter.length }" class="btn btn-sm" @click="resetSelectedCategories">Clear</button>
    </div>
    <hr class="my-2">
    <div class="max-h-80 overflow-y-scroll divide-y px-2">
      <div v-for="( category, i ) in categories" :key="i + category.slug" @click="toggleSelectedCategory( category )" class="flex items-center gap-2 cursor-pointer py-4 text-sm">
        <input type="checkbox" @change="resetPageNumber" :checked="includeCategoryFilter.includes( category )" class="checkbox">
        <div>{{ category.name }}</div>
      </div>
    </div>
  </div>
</template>

